import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Eyebrow.module.scss'

type Tone = 'muted' | 'primary' | 'success'

interface EyebrowProps {
  children: React.ReactNode
  tone?: Tone
}

const toneMap: Record<Tone, string> = {
  muted: styles.toneMuted, primary: styles.tonePrimary, success: styles.toneSuccess,
}

export const Eyebrow: React.FC<EyebrowProps> = ({ children, tone = 'muted' }) => (
  <span className={cx(styles.eyebrow, toneMap[tone])}>{children}</span>
)
